<template>
  <section id="services">
    <div class="services-header">
      <h2>Meine Dienstleistungen</h2>
      <p>Ich biete eine Vielzahl von IT-Dienstleistungen an, um Ihnen den Umgang mit Technik zu erleichtern und Ihre Geräte optimal zu betreuen.</p>
    </div>
    <div class="services-list">
      <div class="service-item">
        <i class="fas fa-tools service-icon"></i>
        <h3>Persönlicher IT-Notdienst</h3>
        <p>Bei technischen Problemen stehe ich Ihnen kurzfristig zur Verfügung, um Ihre Geräte wieder funktionstüchtig zu machen und Ausfallzeiten zu minimieren.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-tachometer-alt service-icon"></i>
        <h3>Beschleunigung Ihres Computers</h3>
        <p>Ich helfe dabei, langsame Computer zu optimieren, damit Sie effizienter arbeiten und Ihre Geräte wieder wie gewohnt nutzen können.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-shopping-cart service-icon"></i>
        <h3>Individuelle Kaufberatung</h3>
        <p>Ich unterstütze Sie beim Kauf von Computern, Handys und der Auswahl passender Internetverträge, abgestimmt auf Ihre persönlichen Bedürfnisse und Anforderungen.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-laptop service-icon"></i>
        <h3>Aufrüstung und Erweiterung Ihrer Geräte</h3>
        <p>Ich berate Sie bei der Erweiterung und Aufrüstung Ihrer Computer, um deren Leistung zu steigern und sie an Ihre aktuellen Bedürfnisse anzupassen.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-desktop service-icon"></i>
        <h3>Maßgeschneiderter Computerbau</h3>
        <p>Ich stelle für Sie individuell angepasste Computer zusammen und übernehme den fachgerechten Aufbau, damit Sie ein Gerät erhalten, das genau Ihren Vorstellungen entspricht.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-network-wired service-icon"></i>
        <h3>Einrichtung Ihres Heimnetzwerks</h3>
        <p>Ich helfe Ihnen bei der Einrichtung und Verwaltung Ihres Heimnetzwerks, um eine stabile und sichere Verbindung für all Ihre Geräte zu gewährleisten.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-shield-alt service-icon"></i>
        <h3>Datenbackup und Sicherheit</h3>
        <p>Ich unterstütze Sie dabei, wichtige Daten zu sichern und effektive Sicherheitsmaßnahmen zu implementieren, um Ihre Informationen vor Verlust und unbefugtem Zugriff zu schützen.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-chalkboard-teacher service-icon"></i>
        <h3>Schulungen und Technikhilfe</h3>
        <p>Ich biete verständliche Schulungen an, um Ihnen den Umgang mit moderner Technik näherzubringen und Ihre Fragen rund um Computer, Smartphones und Internet zu beantworten.</p>
      </div>
      <div class="service-item">
        <i class="fas fa-globe service-icon"></i>
        <h3>Erstellung Ihrer persönlichen Webseite</h3>
        <p>Ich entwickle für Sie eine benutzerfreundliche Webseite, die Ihren individuellen Anforderungen entspricht und Ihre Online-Präsenz stärkt.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection'
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

#services {
  background-color: rgba(0, 1, 54, 0.158);
  border-radius: 40px;
box-shadow: 0 0 10px rgba(0, 0, 0, 0.685); /* Initial subtle glow */
  
  font-family: 'Roboto', sans-serif;

  justify-content: center;
  padding-bottom: 5rem;
  margin: auto;
  width: 80%;
  margin-bottom: 10rem;
  margin-top: 4rem;

  border: 1px solid black
}

.services-header {
  text-align: center;
  margin-bottom: 3rem;
}

.services-header h2 {
  font-size: 3.8rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
  position: relative;
  display: inline-block;
}

.services-header h2::after {
  content: '';
  width: 50px;
  height: 3px;
  background-color: #ff793b;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.services-header p {
  font-size: 1.2rem;
  color: #ffffff;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  
}

.service-item {
  background-color: #fff;
  padding: 2rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  width: 100%;
  max-width: 320px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
  overflow: hidden;
  margin: 1rem;
}

.service-item::before {
  content: '';
  width: 100%;
  height: 5px;
  background-color: #ff793b;
  position: absolute;
  top: 0;
  left: 0;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s;
}

.service-item:hover::before {
  transform: scaleX(1);
}

.service-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.service-icon {
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 1rem;
  transition: color 0.3s;
}

.service-item:hover .service-icon {
  color: #ff793b;
}

.service-item h3 {
  font-size: 1.6rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.service-item p {
  font-size: 1rem;
  color: #555;
  line-height: 1.6;
}
</style>
